import moment from 'moment';
import axios from 'axios';
import service from '../services/index';
import jwt from 'jsonwebtoken';
import { validadorsDadosGerais } from '../commons/constant/validateInputsDateAndTime';
import { BP } from '../commons/constant/empresasBp';
import { decryptData } from '../services/decryptData';

const dicionarioChassisNacionaisBp = [
  '9A',
  '9B',
  '9C',
  '9D',
  '9E',
  '8A',
  '8B',
  '8C',
  '8D',
  '8E',
  '8F',
  '8G',
  '8H',
  '8I',
  '8J',
  '93',
  '94',
  '95',
  '96',
  '97',
  '98',
  '99',
  '8L',
  '8M',
  '8N',
  '8O',
  '8P',
  '8Q',
  '8R',
  '8S',
  '8T',
  '8U',
  '8V',
  '8X',
  '8W',
  '8Z',
  '81',
  '82',
  '9F',
  '9G',
  '9H',
  '9I',
  '9J',
];

export default {
  escondeEmail(email) {
    var maskedEmail = email.replace(/([^@.])/g, '*').split('');
    var previous = '';
    for (let i = 0; i < maskedEmail.length; i++) {
      if (i <= 1 || previous == '.' || previous == '@') {
        maskedEmail[i] = email[i];
      }
      previous = email[i];
    }
    return maskedEmail.join('');
  },

  escondeCelular(celular) {
    var arddd = celular.split(')');
    var ddd = arddd[0] + ')';
    var arrFim = celular.split('-');
    var fimCelular = arrFim[1];
    return ddd + '9****-' + fimCelular;
  },

  getStatusColor(data) {
    if (data == 'Em Aberto' || data == 1) return 'success';
    if (data == 'Aguardando Aprovação' || data == 3) return 'warning';
    if (data == 'Recusada' || data == 2) return 'danger';
    if (data == 'Pendente' || data == 5) return 'blue';
    if (data == 'Em Processo de Vistoria' || data == 6) return 'primary';
    if (data == 'Em Pré-Análise' || data == 7) return '#7B49E7';
    if (data == 'Finalizada' || data == 4) return 'dark';
    return 'danger';
  },

  formataMsParaData(ms) {
    const d = moment.duration(ms);

    if (d.days() > 0) {
      // acima de 24 horas formato "XX dias e YY horas"
      let horasStr = '';
      if (d.hours() > 0)
        horasStr = `e ${d.hours()} hora${d.hours() > 1 ? 's' : ''}`;

      return `${d.days()} dia${d.days() > 1 ? 's' : ''} ${horasStr}`;
    } else {
      // abaixo de 24 horas formato 23:59:59
      return `${d.hours().toString().padStart(2, '0')}:${d
        .minutes()
        .toString()
        .padStart(2, '0')}:${d.seconds().toString().padStart(2, '0')}`;
    }
  },

  calculaIdade(dataNascimento) {
    if (!dataNascimento) {
      return;
    }

    //Recebe como parâmetro uma string com o formato "DD/MM/AAAA"
    const partesData = dataNascimento.split('/');
    const dataNascimentoFormatada = new Date(
      partesData[2],
      partesData[1] - 1,
      partesData[0],
    );
    const dataAtual = new Date();

    const idadeMilissegundos = dataAtual - dataNascimentoFormatada;
    const idadeAnos = Math.floor(idadeMilissegundos / 31557600000); // aproximadamente o número de milissegundos em um ano

    return idadeAnos;
  },

  /**
   * Formata uma data passa com a biblioteca moment.JS
   * @param {*} data data no formato ISO 8601
   * @param {*} formato formato que se quer formatar a data. Padrão DD-MM-YYYY
   * @param {number} add numero de horas que se quer adicionar(valor positivo) ou remover(valor negativo) da hora
   * @returns {string}
   */
  formataDataMomentJS(data, formato = 'DD/MM/YYYY', add = 0) {
    return moment(data).add(add, 'hours').format(formato);
  },

  formataDataISO8601(dataCompleta) {
    const data = dataCompleta.slice(0, 10).split('-').reverse().join('/');
    const hora = dataCompleta.slice(11, 16);
    return `${data} ${hora}`;
  },

  isObjectEmpty(value) {
    const isEmpty =
      value && Object.keys(value).length && value.constructor === Object;

    return !isEmpty;
  },

  /**
   * idsEmpresas = recebe array ou um inteiro
   */
  verificaEmpresaBemProtege(idEmpresa) {
    if (!idEmpresa) return;
    const idsEmpresaBemProtege = this.idsEmpresaBemProtege();

    const idsEmpresas = Array.isArray(idEmpresa) ? [...idEmpresa] : [idEmpresa];
    let isEmpresaBemProtege = false;

    idsEmpresas.forEach((id) => {
      const isBP = idsEmpresaBemProtege.includes(+id);
      if (isBP) isEmpresaBemProtege = true;
    });

    return isEmpresaBemProtege;
  },

  idsEmpresaBemProtege() {
    return [4, 120, 121, 122, 123, 125, 126, 127, 128, 129, 130, 132, 133];
  },

  async getIP() {
    try {
      const { data } = await axios.get('https://api.ipify.org?format=json');
      return data.ip;
    } catch (error) {
      return 'Não foi possível localizar o ip';
    }
  },

  formataReal(valor) {
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  },

  /**
   * Preenche um array de options de um v-select com os dados de um model
   * @param {string} model model dos dados
   * @param {array} array array a ser preenchido
   * @param {string} campoDescricao nome da variavel no model a ser usado na label do select
   * @param {string} campoPK nome da variavel que guarda o id do model
   * @return {array}
   */
  async buscaDadosSelects(model, array, campoDescricao, campoPK) {
    try {
      let res = await service.getAll('g', {}, `${model}/list/`);

      res.data = decryptData(res.data);

      res.data.forEach((element) => {
        array.push({
          id: element[campoPK],
          label: element[campoDescricao],
        });
      });

      array.sort(function (a, b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
      });
      array.unshift({ id: null, label: 'Selecione' });
      return Promise.resolve(array);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Organiza uma lista retornada pelo back-end em dias de acordo com uma coluna data no formato ISO 8601
   * @param {object} dados Lista de retorna pelo back-end
   * @returns {array}
   */
  organizarEmDias(dados) {
    const dias = [];
    for (const dado of dados) {
      const [data, hora] = dado.createdAt.split(' ');
      const index = dias.findIndex((dado) => dado && dado.data === data);

      const newDado = {
        ...dado,
        data,
        hora,
      };
      if (index === -1) {
        dias.push({ data, dados: [newDado] });
      } else {
        dias[index].dados.push(newDado);
      }
    }

    return dias;
  },

  /**
   * Retorna a hora extraida de uma string de data no formato ISO 8601
   * @param {string} data
   * @returns {string}
   */
  pegarHora(data) {
    return data.slice(11, 16);
  },

  /**
   * Pega, decodifica e retorna os dados do token, caso ele exista
   * @param {object} localStorage
   * @returns {object}
   */
  getDecoded(localStorage) {
    const token = localStorage.getItem('user-token');

    if (token) {
      const decoded = jwt.decode(token);
      return {
        idEmpresa: decoded.id_empresa,
        idUsuario: decoded.id_usuario,
        id_perfil: decoded.id_perfil,
      };
    }
  },

  /**
   * Asynchronously verifies if a vehicle is imported based on its chassis number.
   *
   * @async
   * @function
   * @name verificaVeiculoImportado
   * @memberof YourClassName
   * @param {string} chassi - The chassis number of the vehicle.
   * @param {number} idEmpresa - The ID of the company associated with the vehicle.
   * @param {number} [idEmpresaProps=null] - The optional ID of another company associated with the vehicle.
   * @returns {Promise<boolean>} A promise that resolves with a boolean indicating
   * whether the vehicle is imported.
   */
  async verificaVeiculoImportado(chassi, idEmpresa, idEmpresaProps = null) {
    if (chassi) {
      const prefixoChassi = chassi.toUpperCase().slice(0, 2);

      const empresasBP =
        idEmpresa === BP.ERP_SP ||
        idEmpresa === BP.ERP_GERAL ||
        idEmpresaProps === BP.ERP_SP ||
        idEmpresaProps === BP.ERP_GERAL;

      const _dicionarioChassisNacionais = empresasBP
        ? [...dicionarioChassisNacionaisBp]
        : await this.buscarDicionarioChassisNacionais();

      return !_dicionarioChassisNacionais.includes(prefixoChassi);
    }
    return false;
  },

  /**
   * Asynchronously retrieves the dictionary of national chassis numbers.
   * This function performs a POST request to a service endpoint to obtain
   * the dictionary containing chassis numbers for national vehicles.
   *
   * @async
   * @function
   * @name buscarDicionarioChassisNacionais
   * @memberof YourClassName
   * @returns {Promise<Array<string>>} A promise that resolves with an array
   * containing the national chassis numbers dictionary.
   */
  async buscarDicionarioChassisNacionais() {
    const response = await service.post(
      'dicionarios',
      'buscar-dicionario-chassis-nacionais',
      {},
    );
    return response.data;
  },
  verificaEmpresaViavante(idEmpresa) {
    const ID_EMPRESA_VIAVANTE = 121;
    return idEmpresa === ID_EMPRESA_VIAVANTE;
  },
  verificaEmpresasTransdesk(idEmpresa) {
    const ID_EMPRESAS_TRANSDESK = [121, 125, 127];
    return ID_EMPRESAS_TRANSDESK.includes(idEmpresa);
  },
  setFavicon() {
    const linkPagina = window.location.href;
    const regexProd = /adm\.bemprotege\.com/;
    const regexBpMensal = /bpmensal\.com\.br/;
    const regexQA = /adm\.evosolucoes\.com/;
    const resultadoProd = regexProd.test(linkPagina);
    const resultadoBpMensal = regexBpMensal.test(linkPagina);
    const resultadoQA = regexQA.test(linkPagina);

    if (resultadoProd || resultadoBpMensal || resultadoQA) {
      const tituloPagina = document.getElementById('tituloSeuPainel');
      const favicon = document.getElementById('favicon');
      const linkLogoBpIco = '/logo-redonda-bem-protege-favicon.ico';
      const linkLogoBpPng = '/logo-redonda-bem-protege-favicon.png';
      const novoTitulo = 'Painel BPTech';
      favicon.href = linkLogoBpIco;

      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent,
      );
      if (isSafari) {
        favicon.href = linkLogoBpPng;
      }

      tituloPagina.innerText = novoTitulo;
    }
  },

  validateFillingAssociatedDateAndTime(formData) {
    const error = validadorsDadosGerais.find((validation) => {
      const dateValue = formData[validation.form][validation.date];
      const timeValue = formData[validation.form][validation.time];
      return dateValue && !timeValue;
    });

    return error;
  },
  handleObjFormDataReplaceNullToDefaultValue(objFormData, listDataToNormalize) {
    const keysInListException = Object.keys(listDataToNormalize);
    const normalizedData = keysInListException.reduce((accumulator, key) => {
      return {
        ...accumulator,
        [key]:
          objFormData[key] !== null
            ? objFormData[key]
            : listDataToNormalize[key],
      };
    }, objFormData);

    return normalizedData;
  },
};
